import { FormTemplateRuleParameter } from './formTemplateRuleParameter' // eslint-disable-line no-unused-vars
import { FormField, FormFieldType } from '../base/formField' // eslint-disable-line no-unused-vars
import { FormSubmission } from '../base/formSubmission' // eslint-disable-line no-unused-vars

/**
 * A rule defines a function to run on a submission, and optionally tokens to use in the rule.
 *
 * @export
 * @class FormTemplateRule
 */
export class FormTemplateRule {
  /**
   * Creates an instance of FormTemplateRule.
   * @param {any} name The name of the rule. May be displayed to the user.
   * @param {any} [callback=function (submission, index, parameters) { return submission }] A callback that implements the rule. This method takes an array of submissions and tokens, and returns a new array of submissions.
   * @param {[FormTemplateRuleParameter]} parameters The fields that configure the rule.
   * @param {string} [description=''] A user visible description of the rule.
   * @memberof FormTemplateRule
   */
  constructor (name, callback = function (submission, index, parameters) { return submission }, parameters = {}, description = '') {
    this.version = 1
    this.name = name
    this.identifier = this.identifierFromName(name)
    this.callback = callback
    this.parameters = parameters
    this.description = description
  }

  /**
   * Runs the rule on the submission.
   *
   * @param {FormSubmission} submission A form submission.
   * @memberof FormTemplateRule
   */
  run (submission, index = 0) {
    if (Array.isArray(submission)) {
      return submission.map(entry => this.run(entry, submission.indexOf(entry)), this)
    } else {
      const parameters = this.parameters
      return this.callback(submission, index, parameters)
    }
  }

  /**
   * Generates an identifier based on the user visible name.
   *
   * @param {any} name The name of the form.
   * @returns An identifier.
   * @memberof Form
   */
  identifierFromName (name) {
    if (!name) {
      throw new Error('No name to generate rule identifier.')
    }
    return 'rule.' + name.toLowerCase().replace(/\W/g, '')
  }
}
